import * as React from 'react';
import {
  MegaMenuLevels,
  trackMegaMenuNavigation,
} from '_utils/GA4/trackMegaMenuEvents';
import styles from './LinkColumns.module.scss';
import type { LinkColumn } from '../types';
import { MENU_PATH_DELIMITER } from '_utils/GA4/trackMegaMenuEvents';

interface LinkColumnsProps {
  columns: LinkColumn[];
  sideBySide?: boolean;
  menuPathPrefix?: string;
}

export function LinkColumns({
  columns,
  sideBySide,
  menuPathPrefix = '',
}: LinkColumnsProps) {
  const chunkSize = sideBySide ? 2 : 4;
  const rows: LinkColumn[][] = [];
  for (let i = 0; i < columns.length; i += chunkSize) {
    rows.push(columns.slice(i, i + chunkSize));
  }

  return (
    <div className={styles.MenuGroup}>
      {rows.map((row, rowIndex) => (
        <React.Fragment key={rowIndex}>
          {rowIndex > 0 && <div className={styles.RowDivider} />}
          <div className={sideBySide ? styles.NavGroupNarrow : styles.NavGroup}>
            {row.map((column, colIndex) => (
              <div key={colIndex} className={styles.LinkColumn}>
                {column.title &&
                  (column.titleUrl ? (
                    <a
                      href={column.titleUrl}
                      className={styles.GroupTitle}
                      onClick={() =>
                        trackMegaMenuNavigation({
                          level: MegaMenuLevels.level_3,
                          linkUrl: column.titleUrl || null,
                          linkText: column.title,
                          menuPath: `${menuPathPrefix}${MENU_PATH_DELIMITER}${column.title}`,
                        })
                      }
                    >
                      {column.title}
                    </a>
                  ) : (
                    <span className={styles.GroupTitle}>{column.title}</span>
                  ))}
                <div className={styles.Links}>
                  {column.links.map((link, linkIndex) => (
                    <a
                      key={linkIndex}
                      href={link.url}
                      className={styles.SimpleLink}
                      onClick={() =>
                        trackMegaMenuNavigation({
                          level: MegaMenuLevels.level_4,
                          linkUrl: link.url,
                          linkText: link.label,
                          menuPath: `${menuPathPrefix}${MENU_PATH_DELIMITER}${column.title}${MENU_PATH_DELIMITER}${link.label}`,
                        })
                      }
                    >
                      {link.label}
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}
